import type { RouteObject } from "react-router";
export const deliveryRoute: RouteObject = {
  path: "delivery",
  async lazy() {
    const { DeliveryPage } = await import("./DeliveryPage");
    return {
      Component: DeliveryPage,
    };
  },
  children: [
    {
      index: true,
      async lazy() {
        const { DeliveryModuleListPage } = await import("./DeliveryPage");
        return {
          Component: DeliveryModuleListPage,
        };
      },
    },
    {
      id: "distribution-units",
      path: "bundles",
      async lazy() {
        const { DistributionUnitListPage } = await import("../../../distributionUnits/DistributionUnitListPage.tsx");
        return {
          Component: DistributionUnitListPage,
        };
      },
    },
  ],
};
